import React from "react";

const ImageArrowUp = ({ className = "" }) => {
	return (
		<svg
			className={`image-arrow-up ${className}`}
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<polygon
				className="image-fill-color"
				points="18.1,17 11.6,10.5 5.1,17.1 5.1,14.5 11.6,7.9 18.1,14.4"
			></polygon>
		</svg>
	);
};

export default ImageArrowUp;
